// Maps a lane `FilterGroupLeaf` to the `FilterLaneKind` it renders under.
// Trivial for perspective/arc (the leaf's own `kind` discriminant IS the
// lane), but a `measures_into` relationship leaf presents under the
// `measure` lane, not `relationship` — see `types/filterLane.ts` and
// `isMeasureRelationship` (spec "the measure lane is a presentation rule,
// not a type"). Shared by `FilterGroupNodeMolecule` and
// `LaneFilterRowMolecule` so the two never disagree on which glyph a leaf
// renders.
import {
  isArcLeaf,
  isMeasureRelationship,
  isPerspectiveLeaf,
  isRelationshipLeaf,
} from '@center-platform/spheres/filters';
import type { ArcFilterLeaf, PerspectiveFilterLeaf, RelationshipFilterLeaf } from 'types/filters';
import type { FilterLaneKind } from '../types/filterLane';

export type LaneLeaf = PerspectiveFilterLeaf | RelationshipFilterLeaf | ArcFilterLeaf;

export function getLaneForLeaf(leaf: LaneLeaf): FilterLaneKind {
  if (isMeasureRelationship(leaf)) return 'measure';
  if (isPerspectiveLeaf(leaf)) return 'perspective';
  if (isRelationshipLeaf(leaf)) return 'relationship';
  if (isArcLeaf(leaf)) return 'arc';
  // Exhaustiveness guard — a new `FilterGroupLeaf.kind` must be handled above.
  const exhaustive: never = leaf;
  throw new Error(`getLaneForLeaf: unhandled leaf kind ${JSON.stringify(exhaustive)}`);
}
